/**
 * The bookmark's outline, shared by the bookmark and its slashed sibling: a
 * tall ribbon with a notch cut up into its foot, every corner rounded — its
 * top corners broadly, its two points and the notch more tightly, so the
 * points still read as points.
 */import roundedPolygon from"web/shared/icons/glyphs/roundedPolygon";// Clockwise from the top left: the top corners, the right point, the
// notch, and the left point.
const CORNERS=[{x:5,y:3},{x:19,y:3},{x:19,y:21},{x:12,y:17},{x:5,y:21}];const ROUNDINGS=[3,3,1.6,1.2,1.6];export const BOOKMARK_OUTLINE=roundedPolygon(CORNERS,index=>ROUNDINGS[index]);